import { ComponentLinkBuying } from "src/Components/ClaimPointFromEcom";
export const PageLinkBuying = () => {
    return <ComponentLinkBuying />;
};
